import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, ViewChild, HostListener } from '@angular/core';
import { HeaderAction, NavAction } from '@frontend-site/main-header/domain';
import { MatMenuTrigger } from '@angular/material/menu';
import { ColorName } from '@panaya/ui';

@Component({
    selector: 'p-main-header-actions',
    templateUrl: './main-header-actions.component.html',
    styleUrls: ['./main-header-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainHeaderActionsComponent implements OnInit {
    @Input() actions: HeaderAction[] = [];
    @Input() preventOpenSearch!: boolean | null;
    navAction = NavAction;
    @Input() mode: NavAction | null = null;
    @Input() iconColor: ColorName = 'base-light';
    @Output() iconClickedEvent = new EventEmitter();
    @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger = {} as MatMenuTrigger;
    isMenuOpen = false;

    @HostListener('document:keydown.control.f', ['$event'])
    onOpenKeyPress(event: KeyboardEvent) {
        if (this.shouldPreventSearch()) {
            return;
        }

        if (this.menuTrigger.menuOpen) {
            this.menuTrigger.closeMenu();
            return;
        }

        event.preventDefault();
        this.mode = NavAction.Search;
        this.menuTrigger.openMenu();
    }

    ngOnInit(): void {}

    iconClicked(id: NavAction): void {
        this.mode = id;
        this.iconClickedEvent.emit(this.mode);
    }

    routeClicked(id: NavAction): void {
        this.iconClickedEvent.emit(id);
    }

    toggleMenuOpen(id: NavAction): void {
        if (id === NavAction.Notification) {
            this.isMenuOpen = !this.isMenuOpen;
        }
    }

    private shouldPreventSearch(): boolean {
        return !this.actions.find((action) => action.id === NavAction.Search) || !!this.preventOpenSearch;
    }
}
